/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1203
 */

module.exports = {
  formGroup: "style_formGroup__YM_50",
  formItemWrapper: "style_formItemWrapper__IR1UU",
  main: "style_main__IVNUC",
  label: "style_label__M33dB",
  nowrap: "style_nowrap__vtR0c",
  justifyInputContent: "style_justifyInputContent__3962j",
  justifyContentStart: "style_justifyContentStart__1aKkB",
  radioWrapper: "style_radioWrapper__X3QM4",
  colorBlock: "style_colorBlock__1Z7DC",
  slash: "style_slash__12xJr",
  sizeInputBox: "style_sizeInputBox__eQt-n",
  sizeInputNumberBox: "style_sizeInputNumberBox__20JyE",
  typeSelector: "style_typeSelector__kkT_H",
  changeSizeFormItemWrapper: "style_changeSizeFormItemWrapper__1V3FY",
  sizeRadioBox: "style_sizeRadioBox__3X3Cw",
  formWidgetTitle: "style_formWidgetTitle__QCOzt",
  formWidgetTitleWithDisableOrVisible: "style_formWidgetTitleWithDisableOrVisible__2uL1d",
  btnIcon: "style_btnIcon__EEXEk",
  "coco-iconfont": "style_coco-iconfont__1GLT4",
  formInputNumberRow: "style_formInputNumberRow__1POZP",
  formTitle: "style_formTitle__Xo28k",
  textInput: "style_textInput__A5kob",
  space: "style_space__1MUo5",
  optionSwitch: "style_optionSwitch__-bUIv",
  option: "style_option__hp_D_",
  activeOption: "style_activeOption__SRBvY",
  dialog: "style_dialog__2V8wX",
  dialogContent: "style_dialogContent__1JD2z",
  titleWrapper: "style_titleWrapper__2cr0Z",
  title: "style_title__1d8k9",
  textWrapper: "style_textWrapper__K835T",
  line: "style_line__1K7GD",
  firstLine: "style_firstLine__1FMh_",
  secondLine: "style_secondLine__1E48k",
  buttonWrapper: "style_buttonWrapper__3KsBY",
  button: "style_button__IkTTm",
  secondary: "style_secondary__IBsMg",
  primary: "style_primary__1p9Ts",
  textButtonWrapper: "style_textButtonWrapper__3EzfG",
  fontFamilyWrapper: "style_fontFamilyWrapper__ACyhL",
  image: "style_image__365gd",
  downloadIcon: "style_downloadIcon__x88Vb",
  iconBox: "style_iconBox__1UyIK",
  selectedIcon: "style_selectedIcon__1BuZZ",
  disabled: "style_disabled__XRdan",
  selected: "style_selected__1O7KT",
  changeOpacity: "style_changeOpacity__3Xrqm"
}
